<template>
  <div id="betrieb">
    <section id="stage">
      <v-img
        src="../assets/stage/stage_drachenkopf.jpg"
        lazy-src="../assets/stage/80/stage_drachenkopf.jpg"
        :height="this.$vuetify.breakpoint.height / 2.4"
      />
    </section>

    <Intro />
  </div>
</template>

<script>
import Intro from "../components/betrieb/Intro";

export default {
  data() {
    return {
      email: {
        addr: "mail@heberlein-kraeutertee.de",
        text: "mail@heberlein-kraeutertee.de"
      }
    };
  },
  mounted() {
    this.$vuetify.goTo(0);
  },
  components: {
    Intro
  }
};
</script>

<style scoped></style>
